import { makeStyles } from '@material-ui/styles';

const useSkillStyles = makeStyles(theme => ({
  tooltipTitle: {
    fontWeight: 'bold',
    fontSize: theme.typography.caption.fontSize
  },
  detailList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    gridTemplateColumns: [['auto', 'auto']],
    gridTemplateRows: 'auto',
    gridColumnGap: theme.spacing(1),
    gridRowGap: 0,
    justifyContent: 'start',
    justifyItems: 'start',
    alignItems: 'start',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
    hyphens: 'auto',
    display: 'block'
  },
  tooltipContent: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
    hyphens: 'auto',
    margin: theme.spacing(0.25, 0, 0, 0)
  },
  group: {
    margin: 0,
    padding: 0,
    fontStyle: 'italic',
    gridColumnEnd: 'span 2'
  },
  assignment: {
    display: 'contents'
  },
  name: {
    paddingLeft: theme.spacing(1.5)
  },
  rating: {},
  detailListDisplay: {
    display: 'grid'
  }
}));

export default useSkillStyles;
